<template>
  <div>
    <SectionTitle content="Ib. Información del Referido" :has-line="true" />
    <validation-provider :rules="'required'" v-slot="{ errors }">
      <CustomTextArea
        placeholder="Comentario"
        label="Razón y Fuente del Referido:"
        :maxlength="2000"
        v-model="referredReasonValue"
        @input="modelChanged()"
        show-char-count
        :count-classes="['d-block text-right']"
        :disabled="isReadOnly"
        :error="errors[0]"
        :custom-error-msg="'Este campo es requerido'"
      />
    </validation-provider>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomTextArea from '@quisit/custom-text-area';
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    SectionTitle,
    CustomTextArea,
    ValidationProvider,
  },
  data() {
    return {
      referredReasonValue: [],
    };
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    referredReason: {
      type: String,
      default: '',
    },
  },
  watch: {
    referredReason: {
      immediate: true,
      handler(value, oldValue) {
        this.referredReasonValue = value;
        this.modelChanged();
      },
    },
  },
  methods: {
    modelChanged() {
      this.$emit('input', this.referredReasonValue);
    },
  },
};
</script>

<style scoped></style>
